import "../news/stylenews.css";
import { TopMenu } from "../../components/topmenu/TopMenu";

export function Recruite() {
  return (
    <div className="recruite_div">
      <div className="news_list_div">
        <div className="sensor_category">
          <div className="sensor_category_items">
            <div className="category_item category_item_active">
              <span className="category_link">公司招聘</span>
            </div>
          </div>
        </div>
        <div
          id="about_content_id"
          className="news_list_content recruite_top"
          data-animation="once"
          loaded="true"
          min-height="417"
          animated="true"
        >
          <table className="recruite_table">
            <tbody>
              <tr>
                <td>
                  <p className="recruite_txt1">☆销售助理</p>
                </td>
                <td>
                  <p className="recruite_txt1">☆遥感应用工程师</p>
                </td>
                <td>
                  <p className="recruite_txt1">☆遥感数据客服工程师</p>
                </td>
              </tr>
              <tr>
                <td>
                  <p className="recruite_txt2">晋升空间：</p>
                  <p className="recruite_txt2">
                    销售助理---区域经理---大客户经理--行业销售总监
                  </p>
                </td>
                <td>
                  <p className="recruite_txt2">晋升空间：</p>
                  <p className="recruite_txt2">
                    技术工程师---项目经理---行业技术总监
                  </p>
                </td>
                <td>
                  <p className="recruite_txt2">晋升空间：</p>
                  <p className="recruite_txt2">
                    客服工程师---方案质检经理---客服部经理
                  </p>
                </td>
              </tr>
              <tr>
                <td>
                  <p className="recruite_txt2">
                    1)从事遥感影像产品及服务销售推广工作；
                  </p>
                  <p className="recruite_txt2">
                    2)喜欢与人交流，具有良好的沟通能力，
                  </p>
                  <p className="recruite_txt2">
                    有一定的抗压能力，能接受短期出差；
                  </p>
                  <p className="recruite_txt2">
                    3)遥感、测绘、地信、地学等相关专业优先；
                  </p>
                  <p className="recruite_txt2">4)有相关销售经验者优先录用；</p>
                  <p className="recruite_txt2">5)本科及以上学历。</p>
                </td>
                <td>
                  <p className="recruite_txt2">
                    1)从事遥感应用方案编写、信息提取与分析、报告撰写；
                  </p>
                  <p className="recruite_txt2">
                    2)较强的遥感专业技术能力，有一定的抗压能力；
                  </p>
                  <p className="recruite_txt2">
                    3)遥感、测绘、地信、地学等相关专业优先；
                  </p>
                  <p className="recruite_txt2">4)提前实习者优先录用；</p>
                  <p className="recruite_txt2">5)硕士及以上学历。</p>
                  <p className="recruite_txt2">&nbsp;</p>
                </td>
                <td>
                  <p className="recruite_txt2">
                    1)从事遥感数据查询、管理、用户需求方案制作；
                  </p>
                  <p className="recruite_txt2">
                    2)责任心强，具有良好的沟通能力；
                  </p>
                  <p className="recruite_txt2">
                    3)遥感、测绘、地信、地学等相关专业优先；
                  </p>
                  <p className="recruite_txt2">4)提前实习者优先录用；</p>
                  <p className="recruite_txt2">5)本科学历。</p>
                  <p className="recruite_txt2">&nbsp;</p>
                </td>
              </tr>
              <tr>
                <td colspan="3" className="hr_email">
                  <p className="recruite_txt2">
                    有意者请将个人简历发送到邮箱：zhaopin@earthstar.com.cn
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <TopMenu />
    </div>
  );
}
